import { reportUnexpectedClientError } from './client-error.service'


const DEFAULT_NOTIFICATION_SOUND_URL = '/assets/crm_notification.mp3'
const SOUND_DEDUPE_MS = 7000


class ApplicationNotificationSoundService {
    private audio: HTMLAudioElement | null = null
    private audioUrl = ''
    private lastPlayedAtByKey = new Map<string, number>()

    unlock = () => {
        const audio = this.getAudio(DEFAULT_NOTIFICATION_SOUND_URL)

        audio.muted = true
        audio.play().then(() => {
            audio.pause()
            audio.currentTime = 0
            audio.muted = false
        }).catch((error) => {
            audio.muted = false
            this.reportPlaybackError(error, 'ApplicationNotificationSound.unlock')
        })
    }

    play = (notificationKey: string, soundUrl: string = DEFAULT_NOTIFICATION_SOUND_URL) => {
        if (this.isRecentlyPlayed(notificationKey)) return

        const audio = this.getAudio(soundUrl)
        audio.muted = false
        audio.currentTime = 0
        audio.play().catch((error) => this.reportPlaybackError(error, 'ApplicationNotificationSound.play'))
    }

    private getAudio = (soundUrl: string) => {
        const nextAudioUrl = new URL(soundUrl, window.location.origin).href

        if (!this.audio || this.audioUrl !== nextAudioUrl) {
            this.audio = new Audio(nextAudioUrl)
            this.audio.preload = 'auto'
            this.audio.volume = 1
            this.audioUrl = nextAudioUrl
        }

        return this.audio
    }

    private isRecentlyPlayed = (notificationKey: string) => {
        const now = Date.now()

        for (const [key, timestamp] of this.lastPlayedAtByKey) {
            if (now - timestamp > SOUND_DEDUPE_MS) {
                this.lastPlayedAtByKey.delete(key)
            }
        }

        if (this.lastPlayedAtByKey.has(notificationKey)) return true

        this.lastPlayedAtByKey.set(notificationKey, now)
        return false
    }

    private reportPlaybackError = (error: unknown, context: string) => {
        const isExpectedPlaybackDenial = error instanceof DOMException
            && ['AbortError', 'NotAllowedError'].includes(error.name)
        if (!isExpectedPlaybackDenial) reportUnexpectedClientError(error, context)
    }
}

const applicationNotificationSoundService = new ApplicationNotificationSoundService()

export default applicationNotificationSoundService